@if (isPopover) {
  <div class="popover-wrapper">
    <button
      [attr.aria-expanded]="isPopoverOpen"
      analytics-on
      analytics-event="click"
      analytics-category="Share"
      class="icon-share"
      [class.active]="isPopoverOpen"
      [attr.aria-label]="'Share ' + text.replace('- via @uTest', '') + type"
      (click)="togglePopover()">
    </button>
    <div class="popover-container" [class.open]="isPopoverOpen">
      <ng-container #popoverContainer></ng-container>
    </div>
  </div>
}

@if (!isPopover) {
  <span>
    @if (!isLightTester) {
      <a
        href="#"
        title="Share on X"
        class="icon-x-material"
      (click)="openTwitter($event)"></a>
    }
    @if (isLightTester) {
      <a
        href="#"
        title="Share on X"
        class="icon-x-material"
      (click)="checkLightTester($event)"></a>
    }
    @if (!isLightTester) {
      <a
        href="#"
        title="Share on LinkedIn"
        class="icon-linkedin-material"
      (click)="openLinkedIn($event)"></a>
    }
    @if (isLightTester) {
      <a
        href="#"
        title="Share on LinkedIn"
        class="icon-linkedin-material"
      (click)="checkLightTester($event)"></a>
    }
  </span>
}
